<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">
<!--        <preLoader v-if="loader"></preLoader>-->
        <div class="container">
            <div class="form-group" style="margin-top: 30px">

                <router-link :to="{path: '/field/create'}" class="btn btn-success">Add Field</router-link>
<!--                <button type="button" class="btn btn-default" style="float: left"-->
<!--                        v-on:click="tableToExcel('testTable', 'W3C Example Table')" >{{ $t('Excel Output List') }}</button>-->

            </div>



            <div class="panel panel-default ">
                <div class="panel-heading"></div>
                <div class="panel-body  ">
                    <div class="table-responsive">



                        <table   id="testTable"  class="table table-bordered table-striped table-hover">
                            <thead>
                            <tr>



                                <th>ردیف </th>
                                <th>عنوان  </th>

                                <th>نوع </th>
                                <th>وضعیت </th>

                                <th width="100">&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr id="items" v-for="(item, index) in items" :key="index">
                                <td>{{index+1 }}</td>

<!--                                <td > <span v-if="item.process">{{ item.process.title }}</span></td>-->

                                <td>{{ item.title }}</td>

                                <td>{{ item.type}}</td>
                                <td>{{ item.state}}</td>

                                <!--<td v-text="filteritem(item.state)">{{ item.state  }}</td>-->

                                <td>
                                    <router-link :to="{path: '/field/edit/'+item.id, params: {id: item.id}}"
                                                 class="btn btn-xs btn-default">
                                        {{ $t('Edit') }}
                                    </router-link>
                                    <a href="javascript: void(0)" class="btn btn-xs btn-danger"
                                       v-on:click="deleteEntry(item.id, index)">
                                        حذف
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- Trigger the modal with a button -->

                        <!-- Modal -->

                    </div>
                </div>
            </div>
            <div class="col-xs-12 text-center">
                <pagination :api="`/api/fields`" @pagnationChangeDate='pagnation'></pagination>

            </div>














        </div>
    </div>
</template>


<script>
    const auth = {
        headers: {
            Authorization: 'bearer ' + localStorage.getItem('token')
        }
    };

    export default {

        data: function () {
            return {
                auth: {
                    headers: {
                        Authorization: 'bearer ' + localStorage.getItem('token')
                    }
                },
                items: [],
                loader:false,


            }
        },


        mounted() {
            this.loader=true
            axios
                .get(`/api/fields`, this.auth)

                    .then(response => {
                    this.items = response.data.data;
                    console.log(this.items,"field");
                    this.loader=false

                })
                .catch(error => {
                    this.loader = false
                    if (error.response.data.message == 'User does not have any of the necessary access rights.') {
                        this.$snotify.warning(rgis.$t('Your access to this section is restricted'));
                    } else {
                        this.$snotify.warning(error.response.data.message);
                    }
                    console.log(error);
                    this.errored = true
                })
                .finally(() => this.loading = false)
        }


        ,
        methods: {


            spliceNumber(number) {
                //  <input class="form-control" id="id_step2-number_2" name="step2-number_2" type="text" data-type="number">

                $("input[data-type='number']").keyup(function (event) {
                    var $this = $(this);
                    var num2 = $this.val().replace(/,/gi, "").split(/(?=(?:\d{3})+$)/).join(",");
                    $this.val(num2);
                });
                if (number !== null) {
                    return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                }

            },



            pagnation(api) {
                // console.log(api,"m")
                axios.get(api, this.auth)
                    .then(response => {
                        // this.current_page = response.data.current_page
                        this.items = response.data.data;
                        //  console.log(response.data.data)
                        // this.pagnationDate = response.data
                        //  console.log(this.pagnationDate)
                    })
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => this.loading = false)
            },
            deleteEntry(id, index) {
                if (confirm(this.$t('Are you sure you want to delete the item?'))) {
                    var app = this;
                    axios.delete(`/api/fields/` + id, app.auth)
                        .then(function (resp) {
                            app.items.splice(index, 1);
                        })
                        .catch(function (resp) {
                            alert(this.$t('Cannot delete item'));
                        });
                }
            },
            filteritem(item) {

                if (item == 1) {
                    return  this.$t('Active')
                } else {
                    return  this.$t('Inactive')
                }
            },

            filteritemType(item) {



                switch (item) {
                    case '1':
                        return  this.$t('In the process of payment')
                        break;
                    case '2':
                        return this.$t('pay')
                        break;
                    case '3':
                        return  this.$t('revoked')
                        break;
                    default:
                        return  this.$t('In the process of payment')
                }



            },




            getRelation(id) {
                // axios.get('/api/payment/CustomerPayment/' + id, this.auth)
                //     .then(function (resp) {
                //         console.log(resp.data.data.id);
                //         return resp.data.data.id;
                //     })
                //     .catch(function (resp) {
                //         return this.$t('Unknown') ;
                //     });
            }
        },




        tableToExcel (table, name) {

            var uri = 'data:application/vnd.ms-excel;base64,'
                , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
                , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
                , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }


            if (!table.nodeType) table = document.getElementById(table)
            var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
            window.location.href = uri + base64(format(template, ctx))

        },


















    }

</script>
<!--<script>-->
<!--export default {-->
<!--computed: {-->
<!--username() {-->
<!--// We will see what `params` is shortly-->
<!--return this.$route.params.username-->
<!--}-->
<!--},-->
<!--methods: {-->
<!--goBack() {-->
<!--window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')-->
<!--}-->
<!--}-->
<!--}-->
<!--</script>-->
